export const formatRelativeTime = (date: string): string => {
  const units = [
    { limit: 24 * 60 * 60 * 1000, name: "day" },
    { limit: 60 * 60 * 1000, name: "hr" },
    { limit: 60 * 1000, name: "min" },
    { limit: 1000, name: "sec" },
  ];

  const parsedDate = !isNaN(Number(date))
    ? new Date(Number(date))
    : new Date(date);
  if (isNaN(parsedDate.getTime())) {
    return "Invalid date";
  }

  const value = parsedDate.getTime() - Date.now();
  const absValue = Math.abs(value);

  // Handle the case when the value is exactly 0
  if (Math.abs(value) < 1000) return "just now";

  let str = "";

  for (const unit of units) {
    const amount = Math.floor(absValue / unit.limit);
    if (amount >= 1) {
      str = `${amount} ${unit.name}${amount > 1 ? "s" : ""}`;
      break;
    }
  }

  // Determine whether the time is in the past or the future
  return value < 0 ? `${str} ago` : `in ${str}`;
};

export const formatTimeLeft = (value: number): string => {
  if (value <= 0) return "0s";

  const units = [
    { label: "d", ms: 24 * 60 * 60 * 1000 },
    { label: "h", ms: 60 * 60 * 1000 },
    { label: "m", ms: 60 * 1000 },
    { label: "s", ms: 1000 },
  ];

  const parts: string[] = [];
  let remainder = value;

  for (const unit of units) {
    const amount = Math.floor(remainder / unit.ms);
    if (amount > 0 || parts.length > 0 || unit.label === "s") {
      parts.push(`${amount}${unit.label}`);
      remainder -= amount * unit.ms;
    }
  }

  return parts.join(" ");
};

export function splitDateAndTime(datetimeString: string): {
  date: string;
  time: string;
} {
  // Regular expression to match valid time formats
  const timeRegex = /^\d{1,2}:\d{2}(?::\d{2})?\s*(?:[AP]M)?$/i;

  // Attempt to split at the last comma
  const lastCommaIndex = datetimeString.lastIndexOf(",");
  if (lastCommaIndex === -1) {
    // No comma found, treat entire string as date
    return { date: datetimeString.trim(), time: "" };
  }

  const datePart = datetimeString.slice(0, lastCommaIndex).trim();
  const timePart = datetimeString.slice(lastCommaIndex + 1).trim();

  // Check if timePart matches a valid time pattern
  if (timeRegex.test(timePart)) {
    return { date: datePart, time: timePart };
  } else {
    // If timePart isn't a valid time, treat the entire string as date
    return { date: datetimeString.trim(), time: "" };
  }
}
